import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["prompt"];

  open() {
    this.element.hidden = false;
    this.promptTarget.focus();
    document.body.style.overflow = "hidden";
  }

  close() {
    this.element.hidden = true;
    document.body.style.overflow = "";
  }

  keydown(e) {
    if (this.element.hidden) return;
    if (e.key === "Escape") this.close();
  }
}
